import { RouteObject } from 'react-router-dom';

import Administration, {
  Environment,
  Environments
} from '../pages/administration';
import { Admin } from '../layouts';
import Protected from '../layouts/protected';
import Organisation from '../pages/organisation';
import { Permission } from '../types/permission';
import Organisations from '../pages/organisations';
import AllUsers from '../pages/administration/allusers';
import AdminFacilitators from '../pages/administration/admin-facilitators';
import AllUserPage from '../pages/administration/alluser';
import OrganisationView from '../pages/organisation-view';
import ActiveEvents from '../pages/administration/active-events';
import SupportTickets from '../pages/administration/support-tickets';
import FeedbackDetailView from '../pages/feedback/feedback-detail-view';
import AdminInviteUser from '../pages/administration/admin-invite-user';
import WstApproval from '../pages/administration/approval/wst-approval';
import EventsManagement from '../pages/administration/events-management';
import ZoneApproval from '../pages/administration/approval/zone-approval';
import AssessmentDetailView from '../pages/assessment/assessment-detail-view';
import { LibrarApprovalPage } from '../pages/administration/library-approval';
import SupportTicketDetail from '../pages/administration/support-ticket-detail';
import { WSTApprovalDetailView } from '../pages/administration/wst-detail-view';
import FeedbackApproval from '../pages/administration/approval/feedback-approval';
import AllUserPermissions from '../pages/administration/reports/alluser-permissions';
import AssessmentApproval from '../pages/administration/approval/assessment-approval';
import GlobalLibrariesPending from '../pages/administration/global-libraries-pending';
import GlobalEventsManagement from '../pages/administration/global-events-management';
import GamesManagement from '../pages/administration/global-libraries/games-management';
import { ZoneManagement } from '../pages/administration/global-libraries/zones-management';
import FeedbacksManagement from '../pages/administration/global-libraries/feedbacks-management';
import DisplayLanguageEdit from '../pages/administration/global-libraries/language/language-edit';
import AssessmentsManagement from '../pages/administration/global-libraries/assessments-management';
import LanguagesManagement from '../pages/administration/global-libraries/language/languages-management';

export const administrationRoutes: RouteObject = {
  path: '/administration',
  element: <Admin />,
  children: [
    {
      element: <Protected allowedRoles={[Permission['Admin']]} />,
      children: [
        { index: true, element: <Administration /> },

        {
          path: 'users/',
          element: <Protected allowedRoles={[Permission['Admin.Users']]} />,
          children: [
            { index: true, element: <AllUsers /> },
            { path: 'invite-user/', element: <AdminInviteUser /> },
            { path: ':id', element: <AllUserPage /> }
          ]
        },

        {
          path: 'facilitators/',
          element: <Protected allowedRoles={[Permission['Admin.Users']]} />,
          children: [
            { index: true, element: <AdminFacilitators /> },
            { path: 'invite-user/', element: <AdminInviteUser /> },
            { path: ':id', element: <AllUserPage /> }
          ]
        },

        {
          path: 'organisations/',
          element: (
            <Protected allowedRoles={[Permission['Admin.Organisations']]} />
          ),
          children: [
            { index: true, element: <Organisations /> },
            { path: ':id', element: <Organisation /> },
            { path: 'new', element: <Organisation /> }
          ]
        },

        {
          path: 'organisation-details/:id',
          element: (
            <Protected allowedRoles={[Permission['Admin.Organisations']]} />
          ),
          children: [{ index: true, element: <OrganisationView /> }]
        },

        {
          path: 'events/manage',
          element: <Protected allowedRoles={[Permission['Admin.Events']]} />,
          children: [{ index: true, element: <EventsManagement /> }]
        },
        {
          path: 'global-events/manage',
          element: <Protected allowedRoles={[Permission['Admin.Events']]} />,
          children: [{ index: true, element: <GlobalEventsManagement /> }]
        },

        {
          path: 'games/manage',
          element: (
            <Protected allowedRoles={[Permission['Admin.PendingApproval']]} />
          ),
          children: [{ index: true, element: <GamesManagement /> }]
        },

        {
          path: 'zones/manage',
          element: (
            <Protected
              allowedRoles={[Permission['Admin.PendingApproval.Zones']]}
            />
          ),
          children: [{ index: true, element: <ZoneManagement /> }]
        },

        {
          path: 'assessments/manage',
          element: (
            <Protected allowedRoles={[Permission['Admin.PendingApproval']]} />
          ),
          children: [{ index: true, element: <AssessmentsManagement /> }]
        },

        {
          path: 'feedbacks/manage',
          element: (
            <Protected allowedRoles={[Permission['Admin.PendingApproval']]} />
          ),
          children: [{ index: true, element: <FeedbacksManagement /> }]
        },

        {
          path: 'languages/manage',
          element: <Protected allowedRoles={[Permission['Admin.Languages']]} />,
          children: [
            { index: true, element: <LanguagesManagement /> },
            { path: ':id', element: <DisplayLanguageEdit /> }
          ]
        },

        {
          path: 'globallibraries/pending/',
          element: (
            <Protected allowedRoles={[Permission['Admin.PendingApproval']]} />
          ),
          children: [{ index: true, element: <GlobalLibrariesPending /> }]
        },

        {
          path: 'libraryapproval/:id',
          element: (
            <Protected allowedRoles={[Permission['Admin.PendingApproval']]} />
          ),
          children: [{ index: true, element: <LibrarApprovalPage /> }]
        },

        {
          path: 'assessments/pending/',
          element: (
            <Protected allowedRoles={[Permission['Admin.PendingApproval']]} />
          ),
          children: [{ index: true, element: <AssessmentApproval /> }]
        },

        {
          path: 'assessment-detail-view/:id',
          element: (
            <Protected allowedRoles={[Permission['Admin.PendingApproval']]} />
          ),
          children: [{ index: true, element: <AssessmentDetailView /> }]
        },

        {
          path: 'feedbacks/pending/',
          element: (
            <Protected allowedRoles={[Permission['Admin.PendingApproval']]} />
          ),
          children: [{ index: true, element: <FeedbackApproval /> }]
        },

        {
          path: 'zones/pending/',
          element: (
            <Protected
              allowedRoles={[Permission['Admin.PendingApproval.Zones']]}
            />
          ),
          children: [{ index: true, element: <ZoneApproval /> }]
        },

        {
          path: 'wst/pending/',
          element: (
            <Protected allowedRoles={[Permission['Admin.PendingApproval.WST']]} />
          ),
          children: [
            { index: true, element: <WstApproval /> },
            {
              path: ':eventId/:playlistId/:id',
              element: <WSTApprovalDetailView />
            }
          ]
        },

        {
          path: 'feedback-detail-view/:id',
          element: (
            <Protected allowedRoles={[Permission['Admin.PendingApproval']]} />
          ),
          children: [{ index: true, element: <FeedbackDetailView /> }]
        },

        {
          path: 'environments/',
          element: (
            <Protected allowedRoles={[Permission['Admin.Environments']]} />
          ),
          children: [{ index: true, element: <Environments /> }]
        },

        {
          path: 'environment/:id',
          element: (
            <Protected allowedRoles={[Permission['Admin.Environments']]} />
          ),
          children: [{ index: true, element: <Environment /> }]
        },

        {
          path: 'support_tickets',
          element: (
            <Protected allowedRoles={[Permission['Admin.SupportTickets']]} />
          ),
          children: [{ index: true, element: <SupportTickets /> }]
        },

        {
          path: 'support_tickets/:id',
          element: (
            <Protected allowedRoles={[Permission['Admin.SupportTickets']]} />
          ),
          children: [{ index: true, element: <SupportTicketDetail /> }]
        },

        {
          path: 'active-events',
          element: (
            <Protected allowedRoles={[Permission['Admin.ActiveEvents']]} />
          ),
          children: [{ index: true, element: <ActiveEvents /> }]
        },

        {
          path: 'reports/userpermissions',
          element: <Protected allowedRoles={[Permission['Admin.Users']]} />,
          children: [{ index: true, element: <AllUserPermissions /> }]
        }
      ]
    }
  ]
};
